// extracted by mini-css-extract-plugin
export default {"paginationContainer":"styles_paginationContainer__z3VEk"};